import { DEFAULTS } from "./defaults.js";
import { DIVIDER_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/node-view-renderers-loadable.js";
const pluginDivider = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: DIVIDER_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginDivider
};
//# sourceMappingURL=viewer-loadable.js.map
